/**
 * @file: 潜在客户信息完善(原跟进)-基于followEditInformation.js
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/8      1.0     Second version 查看 dop-webapp/src/pages/Customer/Follow/Follow.bak.js 逻辑
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent} from "react";
import { Link, Prompt } from "react-router-dom";
import {Alert,Spin,message,Button,Result,Modal,Popconfirm, Input} from 'antd';
import FormFormat from '@/components/FormFormat/FormFormat';
import dayjs from 'dayjs';
import qs from "query-string";
import FollowAction from "./Follow.action";
import {unlock} from "../../../api/common/lock";
import Lang from "@/components/Lang/Lang";
import {isEmpty,isEmptyObject } from '@utils/utils';
import {TargetLabel,NewBuyerLabel} from "@components/StatuLabel/statuBuyerLabel";
import NewBuyerLabelAndHistoryDrawer from "@components/StatuLabel/NewBuyerLabelAndHistoryDrawer";
import Helper from "../../../utils/helper";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import "./InternalFollowEditInformation.less";

export default class InternalFollowEditInformation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            id: parseInt(qs.parse(this.props.location.search).id),
            loading: false,
            // 客户信息补充
            customerExtra: {
                id: null,
                buyerId: null,
                contact: null,
                storeNum: null,
                url: null,
                // isTargetCustomer: 1,
                otherCategory: null,
                isNoPlatformCategory: null,
                isForeignUser: null,
                remark: null,
                position: null,
                salesSkuCount: null,
                sellChannel: null,
                annualSale: null,
                firstFollowerUser: null,
                followerUserId: null,
                manageCategory: null,
                followRemark: null,
                isCorporateEnterprise: null,
                isOneBox: null,
                customerIntentLevel:null,
                socialMediaList:null,
                companyType:null
            },
            showyOptions : [
                {
                    name:'companyType',
                    cnTitle:'公司类型',
                    cnTitleId:'GongSiLeiXing',
                    cnPlaceholder:'请选择公司类型',
                    required:false,
                    cnPlaceholderId:'QingXuanZeGongSiLeiXing',
                    type:"Enum",
                    enumClass:"buy_buyer_company_type",
                    valueKey:"id",
                    className: 'row100',
                    change:(value,option)=>this.changePosition(value,option)
                },
                {
                    name: 'isCorporateEnterprise',//'mainCategoryIds',
                    cnTitle:'是否法人企业',
                    cnTitleId:'ShiFouFaRenQiYe',
                    required:false,
                    type:"RadioButton",
                    radioClass:"is_corporate_enterprise",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name: 'isOneBox',//'mainCategoryIds',
                    cnTitle:'是否 1 箱起订',
                    cnTitleId:'ShiFouXiangQiDing',
                    required:false,
                    type:"RadioButton",
                    radioClass:"is_one_box",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name: 'customerIntentLevel',//'',
                    cnTitle:'成交意向等级',
                    cnTitleId:'ChengJiaoYiXiangDengJi',
                    required:false,
                    type:"BtnSelect",
                    radioClass:"",
                    valueKey:"id",
                    className: 'row100',
                    canClear:true,
                    list:__getDictList("buy_customer_intent_level")
                },
                {
                    name: 'categoryIdList',//'mainCategoryIds',
                    cnTitle:'经营类目',
                    cnTitleId:'JingYingLeiMu',
                    cnPlaceholder:'请选择经营类目',
                    cnPlaceholderId:'QingXuanZeJingYingLeiMu',
                    type:"Category",
                    className: 'row100',
                },
                {
                    name:'sellChannel',
                    cnTitle:'销售渠道',
                    cnTitleId:'XiaoShouQuDao',
                    cnPlaceholder:'请选择渠道',
                    cnPlaceholderId:'QingXuanZeQuDao',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_channels",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'annualSale',
                    cnTitle:'年销售额',
                    cnTitleId:'NianXiaoShouE',
                    cnPlaceholder:'请选择年度销售额',
                    cnPlaceholderId:'QingXuanZeNianDuXiaoShouE',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_amount",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'salesSkuCount',
                    cnTitle:'在售SKU数',
                    cnTitleId:'ZaiShouSKUShu',
                    cnPlaceholder:'请选择在售SKU数',
                    cnPlaceholderId:'QingXuanZeZaiShouSKUShu',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_sku",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'storeNum',
                    cnTitle:'线下门店数量',
                    cnTitleId:'XianXiaMenDianShuLiang',
                    cnPlaceholder:'请填写门店数量',
                    cnPlaceholderId:'QingTianXieMenDianShuLiang',
                    type:"Number",
                    numConfig:{
                        precision:0,
                        min: 1,
                        max: 10000
                    },
                    className: 'row100',
                },
                {
                    name:'url',
                    cnTitle:'公司网址',
                    cnTitleId:'GongSiWangZhi',
                    cnPlaceholder:'请输入公司网址',
                    cnPlaceholderId:'QingShuRuGongSiWangZhi',
                    className: 'row100',
                },
            ]
        }
    }
    // 请选择联系人职务显示法人企业
    changePosition(value){
        const {showyOptions,otherPositionDict={}} = this.state;
        let nList = [... showyOptions]
        let flag = true;//默认 隐藏
        let current = {}
        if(isEmptyObject(otherPositionDict)){
            const list = __getDictList("buy_buyer_company_type")||[];//公司性质
            current = list.find(item=>item.code=="19");//如果是其他 即显示
            this.setState({
                otherPositionDict:current,
            })
        }else {
            current = otherPositionDict;
        }
        if(value==current.id){
            flag = false;
        }
        const Inx = nList.findIndex(item=>item.name=="isCorporateEnterprise");
        nList[Inx]["hidden"] = flag;
        nList[Inx]["required"] = !flag;
        this.setState({
            showyOptions: nList
        })
    }
    /**
     * 客户信息
     */
    getCustomer() {
           this.loading(true);
           FollowAction.postAction("/service/mg/follower/potential/buyer/detail",{
              id: this.state.id,
          }).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    /**
     * 加载中
     */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    submitLoading(flag) {
        this.setState({
            submitLoading: flag,
        });
    }
    handleRes(res){
        const {success,valid,model={}} = res;
        if(success&&valid){
            let myCustomer = {...model}
            for (const key in myCustomer) {
                if (key == "mainCategoryIds") { //主营类目处理
                    const record = myCustomer[key]
                    const list = record.split(",") || [];
                    const nameList = myCustomer.mainCategoryName ? myCustomer.mainCategoryName.split("|") : [];
                    let categoryInit = []
                    list.forEach((item, i) => {
                        categoryInit.push({
                            value: Number(item),
                            label: nameList.length > i ? nameList[i] : ""
                        })
                    })
                    myCustomer["categoryIdList"] = categoryInit
                }
                //公司名称这个字段后面会被修改，用于form ，为了不改已有的其他逻辑，故这里新增一个字段
                if(key=='companyType'){
                    myCustomer['companyTypeName'] = myCustomer['companyType'];
                }
                if (
                    Object.hasOwnProperty.call(myCustomer, key) &&
                    key.includes("DictId") &&
                    myCustomer[key] !== null
                ) {
                    myCustomer[key.replace("DictId", "")] =
                        myCustomer[key].indexOf(",") !== -1
                            ? myCustomer[key]: myCustomer[key]+"";//parseInt(myCustomer[key]);
                }
            }
            this.setState({
                cusModel:myCustomer
            },()=>this.loading(false));
            /*if(myCustomer.companyType){//根据 公司性质 显示法人问题
                this.changePosition(myCustomer.companyType)
            }*/
            this.changePosition(myCustomer.companyType)
        }else{
            if(res.message){
                message.warning(res.message);
            }
            this.loading(false);
        }
    }
    /*
    * 行
    * */
    renderRow(title,value="-"){
        return(<div className={"flex-item-between rowItem lineH_21"}>
            <span className={"fw_500"}>{title}</span><div className={"black66"}>{value}</div>
        </div> )
    }
    /*
    * 提交
    * */
    async postData() {
        const {cusModel, customerExtra} = this.state;
        const res = await this.onRefFormFormat.handleOK();
        if (res && res.success) {
            let values = {...cusModel,...res.data};
            let data = Helper.overwrite(customerExtra, values);//旧逻辑，
            if (values.categoryIdList) {
                let mainCategoryIds = "";
                values.categoryIdList.forEach((item, i) => {
                    mainCategoryIds += (i > 0 ? "," : "") + item.value;
                })
                data["mainCategoryIds"] = mainCategoryIds;// 保存 类目
                // delete customer.categoryIdList;
            }
            this.submitLoading(true);
            FollowAction.putAction("/service/mg/follower/save/potential/buyer/info", data).then(res => this.handleSaveRes(res.data)).catch(err => this.handleSaveRes(err));
        }
    }
    handleSaveRes(res){
        const {success,valid,} = res;
        if (valid && success) {
            message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}));
            setTimeout(()=>this.props.history.push("/customer/Internal"),400);
        } else if(res.message){
            message.error(res.message);
        }else {
            message.info(Lang({id: 'CaoZuoShiBai',default:'操作失败'}));
        }
        this.submitLoading(false);
    }

    /**
     * 复制动作
     ***/
    handleCopy(mobile=''){
        const txt =__getServerLanguage("ZhangHao")+'：'+ mobile+'，' + __getServerLanguage("MiMa")+'：'+ mobile;
        let key = 'execCommandAgent';
        let agent = document.getElementById(key);
        if (!agent) {
            const e = document.createElement('input');
            e.id = key;
            e.style.position = 'absolute';
            e.style.top = '-40px';
            e.style.left = 0;
            document.body.appendChild(e);
            agent = document.getElementById(key);
        }
        agent.value = txt;
        agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        message.success(Lang({id:"FuZhiChengGong",default:"复制成功"}))
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    componentWillMount() {
        this.getCustomer()
    }
    componentDidMount() {
    }
    render() {
        const {loading = true, cusModel={},showyOptions=[],submitLoading=false,} = this.state;
        return (<Spin spinning={loading||submitLoading}>
            <CommonBreadcrumb list={[{name:<Lang id="KeHuXinXi">客户信息</Lang>,link:"/customer/Internal"},{name:<Lang id="WanShanZiLiao">完善资料</Lang>}]}></CommonBreadcrumb>
            <div className="followEditInformation flex-item black89 fw_400 font_14">
                <div className={"leftInfo"}>
                    <div className={"font_24 fw_500 lineH_36"}>{cusModel.code||"-"}</div>
                    <div className={"font_16 lineH_24"}>{cusModel.name||"-"}</div>
                    <div className={"btnLine mb_16 mt_16 flex-item"}>
                        <NewBuyerLabelAndHistoryDrawer statusCode={cusModel.mgFollowStatus}
                                       status={cusModel.mgFollowStatusName}
                                       buyerId={cusModel.id}
                                       labelType={"1030"}//1010:新客标签 1020:成交客户标签 1030：潜在客户
                             />
                    </div>
                    {this.renderRow(<Lang id="LianXiRen">联系人</Lang>,cusModel.contactName)}
                    {this.renderRow(<Lang id="LianXiDianHua">联系电话</Lang>,cusModel.mobile)}
                    {this.renderRow(<Lang id="DianZiYouXiang">电子邮箱</Lang>,cusModel.email)}
                    {this.renderRow(<Lang id="GongSiLeiXing">公司类型</Lang>,cusModel.companyTypeName)}
                    {this.renderRow(<Lang id="GongSiDiZhi">公司地址</Lang>,cusModel.address)}
                    {this.renderRow(<Lang id="ShuiWuHao">纳税人识别号</Lang>,cusModel.taxRegistrationNo)}
                    {this.renderRow(<Lang id="YingYeZhiZhao">营业执照</Lang>,cusModel.businessLicenseNo)}
                    {this.renderRow(<Lang id="YiXiangCaiGouShangPin">意向采购商品</Lang>,<div className={"mainCate"}>{cusModel.mainCategoryName||'-'}</div>)}
                    {this.renderRow(<Lang id="KeHuLaiYuan">客户来源</Lang>,cusModel.buyerFromName)}
                    {this.renderRow(<Lang id="BeiZhu">备注</Lang>,cusModel.remark)}
                </div>
                <div className={"rightForm ml_16"}>
                    <div className={"font_18 fw_500 lineH_27"}><Lang id="KeHuXinXiWanShan">客户信息完善</Lang></div>

                    {!loading&&<div>

                        <FormFormat onRef={this.onRefForm}
                                            options={showyOptions}
                                            size={"middle"}
                                           // formLayout="inline"
                                           className={"flex-item"}
                                            formLayout = "vertical"
                                            initialValues={cusModel} />
                    </div>}
                    <div className={"mb_40"}>
                        <Button type="primary" loading={submitLoading} size="large" onClick={()=>this.postData()}>
                            <Lang id="BaoCun">保存</Lang>
                        </Button>
                        <Button size="large"className={"ml_8"} loading={submitLoading} >
                            <Link to="/customer/Internal">
                                <Lang id="FanHui">返回</Lang>
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
            {/*  离开释放锁  */}
            <Prompt
                message={(location, action) => {
                    if (!location.pathname.startsWith("/dashboard")) {
                        unlock({
                            buyerId: this.state.id,
                        });
                    }
                }}
            />
        </Spin>);
    }
}
